import React, { useEffect, useState } from 'react';
import errorHandler from 'client/utils/error-handler';

import ServiceWorkerContext from './ServiceWorkerContext';

const supported = 'serviceWorker' in navigator;

const ServiceWorkerProvider = ({ children }: { children: React.ReactNode }) => {
  const [registration, setRegistration] = useState(null);
  useEffect(() => {
    if (supported) {
      window.addEventListener('load', async () => {
        try {
          const reg = await navigator.serviceWorker.register('/sw.js');
          setRegistration(reg);
        } catch (error) {
          errorHandler.report(error);
        }
      });
    }
  }, []);
  return <ServiceWorkerContext.Provider value={{ supported, registration }}>{children}</ServiceWorkerContext.Provider>;
};

export default ServiceWorkerProvider;
